import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { BookingService } from '../../services/api/BookingService';
import { TherapistService } from '../../services/api/TherapistService';
import { BookingModel } from '../../models/api/BookingModel';
import { TherapistModel } from '../../models/api/TherapistModel';
import { BookingStatusService } from '../../services/api/BookingStatusService';
import { BookingStatusModel } from '../../models/api/BookingStatusModel';
import { interval, startWith, switchMap } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { BookingStatusResponse } from '../../models/api/BookingStatusResponse';
import { WaitTimePipe } from '../../pipes/wait-time.pipe'

@Component({
  selector: 'app-queue',
  standalone: true,
  imports: [MatButtonModule, MatBottomSheetModule, MatIconModule, MatProgressBarModule, MatDialogModule, WaitTimePipe],
    templateUrl: './queue.component.html',
  styleUrl: './queue.component.scss'
})
export class QueueComponent implements OnInit {

  public bookingDetail: BookingModel | undefined;
  public therapistDetail: TherapistModel | undefined;
  public bookingStatusDetail: BookingStatusModel | undefined;
  public bookingStatusResponse: BookingStatusResponse | undefined;
  public bookingStatusResponse_Origional: BookingStatusResponse | undefined;
  public bookingId: number = 0;
  public bookingGuid: string = "";
  public waitTime: number = 0;
  public therapistChanged: boolean = false;
  private _bottomSheet = inject(MatBottomSheet);
  public bookingAddEdit: number = 0;
  bookingPolingSubscription: any;
  readonly dialog = inject(MatDialog);
  private bookingForm!: FormGroup;

  constructor(private route: ActivatedRoute, private router: Router, private bookingService: BookingService, private therapistService: TherapistService, private bookingStatusService: BookingStatusService, private fb: FormBuilder) {
    const navigation = this.router.getCurrentNavigation();

    if (navigation?.extras?.state?.['bookingAddEdit']) {
      this.bookingAddEdit = navigation?.extras?.state?.['bookingAddEdit'];
    }
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['guid']) {
        this.bookingId = params['guid'];
        this.bookingGuid = params['guid'];
        this.getBookingDetailsFromGuid(this.bookingGuid);
      }
      else {
        this.router.navigate(['client-portal/therapist-list']);
      }
    })
  }

  ngOnDestroy(): void {
    this.bookingPolingSubscription?.unsubscribe();
  }

  getBookingDetailsFromGuid(bookingGuid: string) {
    this.bookingPolingSubscription = interval(3000).pipe(
      startWith(0),
      switchMap(() => this.bookingService.bookingStatus(bookingGuid))
    ).subscribe(data => {
      if (!this.bookingStatusResponse_Origional){
        this.bookingStatusResponse_Origional = data;
      }
      this.bookingStatusResponse = data;
      if (data.statusId === 6 || data.statusId === 7 || data.statusId === 8){
        this.bookingPolingSubscription.unsubscribe();
      }


      if ((this.bookingStatusResponse_Origional.therapistId && this.bookingStatusResponse_Origional.therapistId > 0)){
          if (this.bookingStatusResponse.therapistId !== this.bookingStatusResponse_Origional.therapistId){
            this.therapistChanged = true;
          }
      }
    })
  }


  updateBooking(): void {
    this.router.navigate(['client-portal/book/' + this.bookingGuid], { state: { therapistId: this.bookingStatusResponse?.therapistId, therapistName: this.bookingStatusResponse?.therapistFirstName + ' ' + this.bookingStatusResponse?.therapistLastName?.slice(0,1) } });
  }

  rebook(): void {
    this.router.navigate(['client-portal/therapist-list/']);
  }

  cancelBooking(): void {

    const cancelBookingDialog = this.dialog.open(CancelBookingDialog, {
      panelClass: 'therapist-portal-dialog',
      disableClose: true,
      backdropClass: 'dialog-blur',
    })

    cancelBookingDialog.afterClosed().subscribe(result => {

      if (result) {
        this.bookingService.cancelBooking(this.bookingGuid).subscribe(data => {
          this.getBookingDetailsFromGuid(this.bookingGuid);
        })
            this.bookingPolingSubscription?.unsubscribe();
      }
    })
  }
}


@Component({
  selector: 'cancel-booking-dialog',
  templateUrl: 'booking-cancel-dialog.html',
  standalone: true,
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent]
})

export class CancelBookingDialog {
  constructor(private dialogRef: MatDialogRef<CancelBookingDialog>) { }
}
